<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isUser()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        <div class="card-title">Configurator</div>
                        <div class="card-tools">
                            <!--                        &lt;!&ndash; Collapse Button &ndash;&gt;-->
                            <!--                        <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>-->
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Company:</span
                                        >
                                        <v-select
                                            v-model="params.company"
                                            type="text"
                                            label="name"
                                            :options="companies"
                                            :reduce="
                                                (companies) => companies.code
                                            "
                                            name="company"
                                            placeholder="Select Company"
                                            :value="
                                                (companies) => companies.code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Source Branch:</span
                                        >
                                        <v-select
                                            v-model="params.source_branch"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >BST ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="bst_id"
                                            @keyup.enter="
                                                getLoadedTransferInstructions(
                                                    '/api/getBulkStockTransferData'
                                                )
                                            "
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Upload Status:</span
                                        >
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="upload_status"
                                            readonly
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            @click="getTemplate"
                                        >
                                            Get Sample Template
                                        </button>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="
                                        params.company != null &&
                                        params.source_branch != null
                                    "
                                >
                                    <div class="form-group">
                                        <button
                                            class="btn btn-success"
                                            style="width: 100% !important"
                                            @click="uploadPrompt"
                                        >
                                            Import DataSheet
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />

            <div class="col-md-12" v-if="data != null">
                <div
                    class="card card-danger card-outline"
                    v-if="upload_status == 'Complete'"
                >
                    <p>
                        &nbsp; Parse Count: {{ count }} &nbsp; BST ID:
                        {{ bst_id }}
                    </p>
                </div>
                <br /><br />
                <div class="card card-primay card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Item Code</th>
                                    <th scope="col">Item Name</th>
                                    <th scope="col">Source Branch</th>
                                    <th scope="col">Destination Branch</th>
                                    <th scope="col">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in data">
                                    <td>{{ j.id }}</td>
                                    <td>{{ j.item_code }}</td>
                                    <td>{{ j.item_name }}</td>
                                    <td>{{ j.source_branch_code }}</td>
                                    <td>{{ j.branch_code }}</td>
                                    <td>{{ j.quantity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="
                                getLoadedTransferInstructions(
                                    pagination.prevPageUrl
                                )
                            "
                            @next="
                                getLoadedTransferInstructions(
                                    pagination.nextPageUrl
                                )
                            "
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="uploadModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Bulk Transfer Sheet Import</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            :class="[
                                'form-group',
                                errors.link ? 'has-error' : '',
                            ]"
                        >
                            <label for="file">Excel File</label>
                            <input
                                class="form-control"
                                id="file"
                                type="file"
                                ref="file"
                                name="link"
                                placeholder="Upload Excel"
                                @change="addFile"
                            />
                            <span
                                v-if="errors.link"
                                :class="['badge bg-danger']"
                                >Please add an excel file.</span
                            >
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="uploadFile">
                            Submit
                        </button>
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isUser()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
import { parse } from "postcss";
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading, pagination: Pagination },

    created() {
        this.getCompanies();
        this.getBranches();

        this.fromdate = new Date().toISOString().slice(0, 10);
        this.todate = new Date().toISOString().slice(0, 10);
    },

    data() {
        return {
            receipts: [],
            companies: [],
            branches: [],
            saleorders: [],
            invoices: [],
            company: "",
            branch: "",
            fromdate: "",
            todate: "",
            upload_status: "Pending",
            params: new Form({
                company: null,
                source_branch: null,
            }),
            lshow: false,
            llabel: "Syncing. Do not close or change this page...",
            file: "",
            link: "",
            status: "",
            count: "",
            bst_id: "",
            data: null,
            errors: [],
            generated_data: [],
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        reset() {
            this.getCompanies();
        },
        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },
        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },
        // getTemplate(){
        //     axios({
        //         url: "/api/getBulkStockTransferTemplateExport",
        //         data:{params: this.params},
        //         method: 'post',
        //         responseType: 'blob'
        //     })
        //         .then(response => {
        //             toast.fire({
        //                 icon: 'success',
        //                 title: 'Template Generated'
        //             })
        //             var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        //             saveAs(response.data, "template.xlsx");
        //         })
        // },

        uploadPrompt() {
            $("#uploadModal").modal("show");
        },

        addFile() {
            this.file = this.$refs.file.files[0];
            this.link = this.file;
        },

        uploadFile() {
            var formData = new FormData();
            formData.append("file", this.link);
            formData.append("company", this.params.company);
            formData.append("source_branch", this.params.source_branch);
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios({
                method: "post",
                url: "/api/postBulkStockTransferImport",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    this.data = response.data;
                    toast.fire({
                        type: "success",
                        title: "File Analyzed",
                    });
                    this.errors = [];
                    this.lshow = false;
                    this.status = response.data.Status;
                    this.count = response.data.Count;
                    this.bst_id = response.data.Data;
                    this.upload_status = "Complete";
                    $("#uploadModal").modal("hide");
                    this.getLoadedTransferInstructions();
                })
                .catch((error) => {
                    this.lshow = false;
                    toast.fire({
                        type: "error",
                        title: "Syncing Failed",
                    });
                    this.errors = error.response.data.errors;
                });
        },

        getLoadedTransferInstructions(url = "/api/getBulkStockTransferData") {
            axios.post(url, { id: this.bst_id }).then((response) => {
                this.data = response.data.data;
                this.configPagination(response.data);
                this.upload_status = "Complete";
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
    },
};
</script>
